import Title from "../components/ui/Title";
import Box from "../components/ui/Box";
import { Button } from "../components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Link } from "react-router-dom";
import papierImage from "../assets/img/papier.png";
import numeriqueImage from "../assets/img/numerique.png";

export default function ChoixTypeAbonnementPage() {
  return (
    <>
      <Title className='mb-8'>Type d'abonnement</Title>
      <div className='flex flex-col md:flex-row gap-3'>
        {/* Papier + numérique */}
        <Box className='flex-1 text-center'>
          <div className='text-xl font-bold text-slate-800 mb-3'>Papier + numérique</div>
          <div className='text-sm text-slate-500'>
            11 numéros par an, envoyés en version papier chez vous et accessibles gratuitement en version numérique sur
            l'application mobile L'Abeille de France ou sur le portail ApiConnect.
          </div>
          <div className='w-72 mx-auto'>
            <img src={papierImage} alt="Des revues de l'abeille de france ainsi que leur version numérique" />
          </div>
          <div className='mt-4'>
            <Link to='/sabonner/papier'>
              <Button>Choisir l'abonnement papier + numérique</Button>
            </Link>
          </div>
        </Box>
        {/* Numérique */}
        <Box className='flex-1 text-center'>
          <div className='text-xl font-bold text-slate-800 mb-3'>100% numérique</div>
          <div className='text-sm text-slate-500'>
            11 numéros par an accessibles sur l'application mobile L'Abeille de France (disponible janvier 2025) ou dès
            maintenant sur le portail ApiConnect. Attention, cet abonnement{" "}
            <strong>n'inclut pas la version papier</strong>.
          </div>
          <div className='w-72 mx-auto'>
            <img src={numeriqueImage} alt="Une tablette et un téléphone avec l'application L'Abeille de France" />
          </div>
          <div className='mt-4'>
            <Dialog>
              <DialogTrigger asChild>
                <Button>Choisir l'abonnement numérique</Button>
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Avertissement</DialogTitle>
                  <DialogDescription>
                    Je comprends qu'avec l'abonnement 100% numérique, je ne recevrai pas la version papier de la revue.
                  </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                  <DialogClose asChild>
                    <Button variant='outline'>Annuler</Button>
                  </DialogClose>
                  <Link to='/sabonner/numerique'>
                    <Button type='button'>Compris !</Button>
                  </Link>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          </div>
        </Box>
      </div>
    </>
  );
}
